import { render } from "./BackerCenterProjectsView.vue?vue&type=template&id=fa41da42"
import script from "./BackerCenterProjectsView.vue?vue&type=script&lang=js"
export * from "./BackerCenterProjectsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__